import type { BaseOptionType } from 'antd/es/select';

export const getSelectedOptions = (
  options: BaseOptionType[],
  selectedValues: (number | string | BaseOptionType)[] | null | undefined
): BaseOptionType[] => {
  if (!selectedValues || selectedValues.length === 0) {
    return [];
  }

  const selectedPrimitiveValues = selectedValues.map((item) =>
    typeof item === 'object' && item !== null ? item.value : item
  );

  return options.filter((option) =>
    selectedPrimitiveValues.map(String).includes(String(option.value))
  );
};
